/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import PropTypes from 'prop-types';

import CircleButton from './CircleButton';
import ArrowRight from 'components/images/ArrowRight';
import Circle from 'components/images/Circle';

const NextButton = ({ onClick, alignRight, isDisabled }) => (
  <CircleButton onClick={onClick} alignRight={alignRight} colorClassName="fill-color-middle-gray">
    <ArrowRight fillColor="white" />
  </CircleButton>
);
NextButton.propTypes = {
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
};

export default NextButton;